import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { HttpResponse } from "@angular/common/http";
import { map, tap } from "rxjs/operators";

@Injectable()
export class WebhooksService {
  constructor(private http: HttpClientService) {}

  public nubariumCurpInfo(curp): Observable<any> {
    const params = { curp };
    return this.http
      .post("/api/webhooks/nubarium_curp_info", params)
      .pipe(tap((_) => console.log("WebhooksService.nubariumCurpInfo: Ok.")));
  }

  public metamapStatementsInfo(account_id): Observable<any> {
    let options = { model_id: account_id, model_type: "Account" };
    return this.http
      .get("/api/webhooks/metamap_webhook_info", { params: options })
      .pipe(tap((_) => console.log("metamapStatementsInfo.metamapStatementsInfo: Ok.")));
  }

  public scrappingCurpInfo(curp): Observable<any> {
    const params = { curp };
    return this.http
      .post("/api/webhooks/scrapping_curp_info", params)
      .pipe(tap((_) => console.log("WebhooksService.scrappingCurpInfo: Ok.")));
  }

  public nubariumValidateBankAccount(params): Observable<any> {
    return this.http
      .post("/api/webhooks/nubarium_validate_clabe", params)
      .pipe(tap((_) => console.log("WebhooksService.nubariumValidateBankAccount: Ok.")));
  }
}
